import nextDynamic from 'next/dynamic';

const Content = nextDynamic(() => import('./players-content'), { ssr: false });

export default function Page() {
  return <Content />;
}
